<template>
  <div class="price-info">
    <div class="price-info__title container">
      <h2>
        {{ title }}
      </h2>
    </div>
    <div class="price-info__body container">
      <div
        v-for="(price, idx) of priceList"
        :key="idx"
        class="price-info__prices"
      >
        <p>{{ price.label }}</p>
        <template v-if="price.amount?.old || price.amount?.new">
          <div class="price-info__prices-container">
            <div class="price-info__prices-list">
              <p
                v-if="price.amount.old"
                class="bold price-info__prices-container-old"
              >
                <template v-if="!label">
                  {{ configsStore.currentConfig[1].currencySymbol }}{{ price.amount.old }}
                </template>
                <template v-if="label">
                  {{ label }} {{ price.amount.old }}
                </template>
              </p>
              <p
                v-if="price.amount.new"
                class="bold price-info__prices-container-new"
              >
                <template v-if="!label">
                  {{ configsStore.currentConfig[1].currencySymbol }}{{ price.amount.new }}*
                </template>
                <template v-if="label">
                  {{ price.amount.new }} {{ label }}*
                </template>
              </p>
            </div>
            <p class="price-info__prices-container-label">
              {{ price.amount.label }}
            </p>
          </div>
        </template>
        <template v-else>
          <p class="bold">
            <template v-if="!label">
              {{ price.amount }}
            </template>
            <template v-if="label">
              {{ price.amount }} {{ label }}
            </template>
          </p>
        </template>
      </div>
      <div
        v-if="description"
        class="price-info__description"
      >
        <p>
          {{ description }}
        </p>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { PropType } from 'vue';

defineProps({
  title: { type: String, required: true },
  priceList: {
    type: Array as PropType<any>,
    required: true,
  },
  description: String,
  label: { type: String, default: '' },
});
const { locale } = useI18n();
const configsStore = usePaymentConfigs(locale);
</script>

<style lang="scss" scoped>
.price-info {
  &__title {
    background: $gray-bg;

    & h2 {
      font-family: $primary-fonts;
      font-size: 14px;
      font-style: normal;
      font-weight: 700;
      line-height: 150%; /* 21px */
      text-transform: uppercase;
      padding: 16px 0;
    }
  }

  &__body {
    padding: 0 32px;
  }

  &__prices {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 0;

    & p {
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 150%; /* 21px */

      &.bold {
        font-weight: 600;
      }
    }
  }

  &__prices-container {
    display: flex;
    align-items: flex-end;
    flex-direction: column;
  }

  &__prices-list {
    display: flex;
    align-items: center;
    gap: 4px;
  }

  &__prices-container-old {
    opacity: 0.5;
    text-decoration: line-through;
  }

  &__prices-container-label {
    font-size: 11px !important;
    font-style: normal;
    font-weight: 400;
    line-height: 150%; /* 16.5px */
  }

  &__description {
    padding: 16px 0;
    border-top: 1px solid $gray-bg;
    & p {
      font-size: 14px;
      font-style: italic;
      font-weight: 400;
      line-height: 150%; /* 21px */
      opacity: 0.5;
    }
  }
}
</style>
